import { BREAKPOINTS } from './breakpoints';

/**
 *  Utility function to check if we are in browser context of in Server or Node.js env.
 */
export const isServer = () => typeof window === 'undefined';

/**
 * Utility function to check if we are in browser context of in NodeJS env.
 */
export const isClient = (force?: boolean | undefined): boolean =>
  typeof force === 'boolean' ? force : typeof window !== 'undefined';

// As found on https://github.com/react-component/select/blob/423f860b8582e8d105ce67d189da096db36c0ba6/src/utils/commonUtil.ts
export const isBrowserClient =
  typeof window !== 'undefined' && Boolean(window.document && window.document.documentElement);
// Is client side and not jsdom
// @ts-ignore
export const isNodeClient = process.env.NODE_ENV !== 'test' && isBrowserClient;
/**
 * Check if is Landscape for SSR is false
 */
export const isLandscapeOriented = (): boolean =>
  isClient() ? window.matchMedia('(orientation: landscape)').matches : false;

/**
 * Check if is Portrait for SSR true
 */
export const isPortraitOriented = (): boolean =>
  isClient() ? window.matchMedia('(orientation: portrait)').matches : true;

/**
 * is Mobile Device
 * iPhone iPad iPod Android
 */
export const isMobile = (force?: boolean | undefined): boolean => {
  if (isClient(force)) {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ?? false;
    // return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || false;
  } else {
    return false;
  }
};

/**
 * Get Window Width or SSR BREAKPOINTS.MOBILE
 */
export const getWindowWidth = (): number => {
  if (isClient()) {
    return window?.innerWidth || document?.documentElement?.clientWidth || document?.body?.clientWidth;
  } else {
    return BREAKPOINTS.MOBILE;
  }
};

export const isClientDesktop: boolean = isServer() ? false : !isMobile() || false;
